"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStorage = void 0;
const Logger_1 = require("../utils/Logger");
const __1 = require("..");
const logger = new Logger_1.Logger('STORAGE');
exports.getStorage = async () => {
    if (await __1.ChromeStorage.isSupported()) {
        logger.log('getStorage', 'USING CHROME STORAGE');
        return new __1.ChromeStorage();
    }
    else if (await __1.LocalStorage.isSupported()) {
        logger.log('getStorage', 'USING LOCAL STORAGE');
        return new __1.LocalStorage();
    }
    else {
        throw new Error('no storage type supported');
    }
};
//# sourceMappingURL=getStorage.js.map